import { ActionProps } from '../types'
import { Avatar, Flex, Form, Input, List, Space, Typography } from 'antd'
import { UserSplitConfig, UserSplitOption, UserSplitOptionConfig } from '../types/UserSplitConfig'
import { RightOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl'
import { StepConfig } from '../api/enrollement'

const UserSplitAction: React.FC<ActionProps<UserSplitConfig>> = ({ config, form, setDisableContinue, onContinue }) => {

  const { $t } = useIntl()

  const availableOptions: UserSplitOption[] = [];
  const { Link } = Typography

  const initSplitOptions = (stepConfig: StepConfig) => {

    for (const key in stepConfig.options) {
      const step = stepConfig.options[key];
      const config = JSON.parse(step.actionConfiguration!) as UserSplitOptionConfig;
      availableOptions.push({
        stepId: step.stepId,
        actionId: step.actionId,
        actionType: stepConfig.actionType,
        optionName: step.optionName ? step.optionName : config.title,
        actionConfig: config
      });
    }
  }
  initSplitOptions(config.stepConfig || {});
  const onOptionSelect = (item: UserSplitOption) => {
    form.setFieldsValue({
      actionType: item.actionType,
      selectedStepId: item.stepId,
      selectedActionId: item.actionId,
      shortName: item.optionName ? item.optionName : item.actionConfig.title
    })
    onContinue(true);
  }
  return (
    <>
      <Space direction='vertical' size='middle' style={{ width: '100%' }}>

        <label>{$t({ defaultMessage: 'Select an option to connect' })}</label>

        <List size='large'
          itemLayout='horizontal'
          dataSource={availableOptions}
          renderItem={(item: UserSplitOption, index) => (
            <Link>
              <List.Item onClick={() => onOptionSelect(item)}
                style={{
                  'padding': '8px 4px 8px 4px',
                  'margin': '0px 0px 8px 0px', 'backgroundColor': '#f2f2f2', 'border': '1px solid #dfdfdf',
                  'borderRadius': '6px'
                }}>


                <List.Item.Meta data-testid={`op-${index}`}
                  avatar={<Avatar data-testid={`opIcon-${index}`} size={'large'} shape='square' src={item?.actionConfig.iconFileLocation} alt='' />}
                  title={<Flex data-testid={`opName-${index}`} style={{ padding: '8px 0px 0px 0px' }} >{item.optionName ? item.optionName : item.actionConfig.title}</Flex>}
                />
                <RightOutlined className='arrow-icon' />

              </List.Item>
            </Link>
          )}
        />


        <Form.Item hidden={true} name={'shortName'} noStyle>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item hidden={true} name={'selectedStepId'} noStyle>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item hidden={true} name={'selectedActionId'} noStyle>
          <Input type="hidden" />
        </Form.Item>
      </Space>
    </>
  )
}

export default UserSplitAction